import * as React from 'react';
const SvgViewList = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19.74 17.55a.55.55 0 0 0-.25-.05H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.9c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H19.2c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-.9c0-.28 0-.42-.05-.53a.52.52 0 0 0-.22-.22zM19.96 4.27a.52.52 0 0 0-.22-.22.55.55 0 0 0-.25-.05H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22C4 4.38 4 4.52 4 4.8v.9c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H19.2c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-.9c0-.28 0-.42-.05-.53zM19.74 8.55a.55.55 0 0 0-.25-.05H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22C4 8.88 4 9.02 4 9.3v.9c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H19.2c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-.9c0-.28 0-.42-.05-.53a.52.52 0 0 0-.22-.22zM19.74 13.05a.55.55 0 0 0-.25-.05H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.9c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H19.2c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-.9c0-.28 0-.42-.05-.53a.52.52 0 0 0-.22-.22z"
    />
  </svg>
);
export default SvgViewList;
